import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src='/img/logoHorizontalBranca1.png' alt="IAC Buritama" style={{ height: '32px', width: 'auto', opacity: 0.85 }} />
        </div>
        <div className="footer-center">
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} IAC Buritama &mdash; Todos os direitos reservados.
          </p>
        </div>
        <div className="footer-right">
          <Link to="/politica-de-privacidade" className="footer-admin-link">
            Política de Privacidade
          </Link>
          <Link to="/termos-de-uso" className="footer-admin-link">
            Termos de Uso
          </Link>
          <Link to="/admin" className="footer-admin-link">
            Área Administrativa
          </Link>
        </div>
      </div>
    </footer>
  );
}
